const DEFAULT_SEPERATOR = '&';
const DEFAULT_KV_SEPERATOR = '=';

export default class KVParser {
  constructor({
    seperator = DEFAULT_SEPERATOR,
    kvSeperator = DEFAULT_KV_SEPERATOR,
    skipEmpty = false,
    decode = true,
  } = {}) {
    this._seperator = seperator;
    this._kvSeperator = kvSeperator;
    this._skipEmpty = skipEmpty;
    this._decode = decode;
  }
  createPattern() {
    return new RegExp(`([^\\${this._seperator}\\${this._kvSeperator}]+)(\\${this._kvSeperator}([^\\${this._seperator}\\${this._kvSeperator}]*))?`, 'g');
  }
  parse(content) {
    if (typeof content !== 'string' || content === '') {
      return {};
    }
    const regexp = this.createPattern();
    const params = {};
    let matches;
    while (matches = regexp.exec(content)) {
      const [, k] = matches;
      let [, , , v] = matches;
      const isEmpty = v === null || v === undefined || v === '';
      if (this._skipEmpty && isEmpty) {
        continue;
      }
      if (isEmpty) {
        v = '';
      }
      params[k] = this._decode ? decodeURIComponent(v) : v;
    }

    return params;
  }
}
